import * as React from 'react';

const LocationArrow16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.64 9.36 1.427 4.637L14.13 1.87 2.003 7.933 6.64 9.36ZM15.65.35a1.2 1.2 0 0 1 .225 1.386l-6.8 13.6a1.202 1.202 0 0 1-2.221-.184L5.44 10.56.847 9.147a1.201 1.201 0 0 1-.184-2.22l13.6-6.8A1.202 1.202 0 0 1 15.65.35Z",
    clipRule: "evenodd"
  }
));
LocationArrow16.Size = 16;
LocationArrow16.Title = "LocationArrow";

export { LocationArrow16 as default };
